import { HStack, usePropsResolution, Pressable, VStack } from 'native-base';
import React from 'react';
import { RightOutlined } from '../Icon';
import { Text } from '../Text';
import type { IListItemProps } from './ListItem.types';

const ListItem = ({
  description,
  direction = 'horizontal',
  onPress,
  RightAddon,
  title,
  testID = 'ListItem',
  ...props
}: IListItemProps) => {
  const { _container, _content, _description, _icon, _title } =
    usePropsResolution('ListItem', { direction });

  const ListItemContent =
    direction === 'horizontal' ? (
      <HStack {..._content}>
        <Text testID={`${testID}--Title`} {..._title}>
          {title}
        </Text>
        <Text testID={`${testID}--Description`} {..._description}>
          {description}
        </Text>
      </HStack>
    ) : (
      <VStack {..._content}>
        <Text testID={`${testID}--Title`} {..._title}>
          {title}
        </Text>
        <Text testID={`${testID}--Description`} {..._description}>
          {description}
        </Text>
      </VStack>
    );

  return onPress ? (
    <Pressable onPress={onPress} testID={testID} {..._container} {...props}>
      {ListItemContent}
      {RightAddon ?? <RightOutlined {..._icon} />}
    </Pressable>
  ) : (
    <HStack testID={testID} {..._container} {...props}>
      {ListItemContent}
      {RightAddon}
    </HStack>
  );
};

export default ListItem;
